var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.311,
    height: 29.311,
    viewBox: "0 0 29.311 29.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(-554 -848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M4,10.828V7.414A3.414,3.414,0,0,1,7.414,4h3.414",
    transform: "translate(551 845)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M4,16v3.414a3.414,3.414,0,0,0,3.414,3.414h3.414",
    transform: "translate(551 853.483)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M16,4h3.414a3.414,3.414,0,0,1,3.414,3.414v3.414",
    transform: "translate(559.483 845)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M16,22.828h3.414a3.414,3.414,0,0,0,3.414-3.414V16",
    transform: "translate(559.483 853.483)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M8,13.121A5.121,5.121,0,1,0,13.121,8,5.121,5.121,0,0,0,8,13.121",
    transform: "translate(553.828 847.828)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M17.767,17.767,13.5,13.5",
    transform: "translate(557.716 851.716)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.51e8a2e50d91ff1b15f06d27942a7a94.svg";
export { ForwardRef as ReactComponent };